import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { onChangeClassParkingFilter } from '../../../ac/onChangeMapFilters';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { ClassParkingRebalancedTypes } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const ClassifiedParkingFiltersComponent = ({
    mapFilters,
    onChangeClassParkingFilter,
}) => (
    <div>
        <div className={styles.legHead}>{t`Класс парковки`}:</div>
        <div className={styles.checkboxIconGrid}>
            {
                ClassParkingRebalancedTypes.map(({ value, color, label }) => (
                    <Fragment key={value}>
                        <CircleLegend
                            fill={color}
                            width='2vw'
                            height='2vw'
                            opacity='0.8'
                        />
                        <label htmlFor={label.id}>{i18n._(label)}</label>
                        <div>
                            <label className={styles.switch}>
                                <input
                                    type='checkbox'
                                    name='ClassifiedParkings'
                                    id={value}
                                    checked={mapFilters.parkingClassLotStatuses.includes(value)}
                                    value={value}
                                    onChange={onChangeClassParkingFilter}
                                />
                                <span className={classnames(styles.sliderRound, styles.slider)} />
                            </label>
                        </div>
                    </Fragment>
                ))
            }
        </div>
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeClassParkingFilter })(ClassifiedParkingFiltersComponent);

export const ClassifiedParkingRebalancedFilter = withDisplayedLayersCheck(ConnectedComponent, t`Классифицированные парковки (ребаланс)`);
